import type { GenesysCloudAPIOptions } from '../types/genesys-cloud-api-data';

export const GenesysCloudAPIData: GenesysCloudAPIOptions = [
    {
        short: 'N. Virginia',
        label: 'Americas',
        aws: 'us-east-1',
        auth: 'https://login.mypurecloud.com',
        api: 'https://api.mypurecloud.com',
        apps: 'https://apps.mypurecloud.com',
        env: 'mypurecloud.com',
        dev: false,
    },
    {
        short: 'Ohio',
        label: 'FedRAMP',
        aws: 'us-east-2',
        auth: 'https://login.use2.us-gov-pure.cloud',
        api: 'https://api.use2.us-gov-pure.cloud',
        apps: 'https://apps.use2.us-gov-pure.cloud',
        env: 'use2.us-gov-pure.cloud',
        dev: false,
    },
    {
        short: 'Oregon',
        label: 'Americas',
        aws: 'us-west-2',
        auth: 'https://login.usw2.pure.cloud',
        api: 'https://api.usw2.pure.cloud',
        apps: 'https://apps.usw2.pure.cloud',
        env: 'usw2.pure.cloud',
        dev: false,
    },
    {
        short: 'Central',
        label: 'Americas',
        aws: 'ca-central-1',
        auth: 'https://login.cac1.pure.cloud',
        api: 'https://api.cac1.pure.cloud',
        apps: 'https://apps.cac1.pure.cloud',
        env: 'cac1.pure.cloud',
        dev: false,
    },
    {
        short: 'São Paulo',
        label: 'Americas',
        aws: 'sa-east-1',
        auth: 'https://login.sae1.pure.cloud',
        api: 'https://api.sae1.pure.cloud',
        apps: 'https://apps.sae1.pure.cloud',
        env: 'sae1.pure.cloud',
        dev: false,
    },
    {
        short: 'Central',
        label: 'Mexico',
        aws: 'mx-central-1',
        auth: 'https://login.mxc1.pure.cloud',
        api: 'https://api.mxc1.pure.cloud',
        apps: 'https://apps.mxc1.pure.cloud',
        env: 'mxc1.pure.cloud',
        dev: false,
    },
    {
        short: 'Frankfurt',
        label: 'EMEA',
        aws: 'eu-central-1',
        auth: 'https://login.mypurecloud.de',
        api: 'https://api.mypurecloud.de',
        apps: 'https://apps.mypurecloud.de',
        env: 'mypurecloud.de',
        dev: false,
    },
    {
        short: 'Ireland',
        label: 'EMEA',
        aws: 'eu-west-1',
        auth: 'https://login.mypurecloud.ie',
        api: 'https://api.mypurecloud.ie',
        apps: 'https://apps.mypurecloud.ie',
        env: 'mypurecloud.ie',
        dev: false,
    },
    {
        short: 'London',
        label: 'EMEA',
        aws: 'eu-west-2',
        auth: 'https://login.euw2.pure.cloud',
        api: 'https://api.euw2.pure.cloud',
        apps: 'https://apps.euw2.pure.cloud',
        env: 'euw2.pure.cloud',
        dev: false,
    },
    {
        short: 'Zurich',
        label: 'EMEA',
        aws: 'eu-central-2',
        auth: 'https://login.euc2.pure.cloud',
        api: 'https://api.euc2.pure.cloud',
        apps: 'https://apps.euc2.pure.cloud',
        env: 'euc2.pure.cloud',
        dev: false,
    },
    {
        short: 'UAE',
        label: 'EMEA',
        aws: 'me-central-1',
        auth: 'https://login.mec1.pure.cloud',
        api: 'https://api.mec1.pure.cloud',
        apps: 'https://apps.mec1.pure.cloud',
        env: 'mec1.pure.cloud',
        dev: false,
    },
    {
        short: 'Mumbai',
        label: 'Asia Pacific',
        aws: 'ap-south-1',
        auth: 'https://login.aps1.pure.cloud',
        api: 'https://api.aps1.pure.cloud',
        apps: 'https://apps.aps1.pure.cloud',
        env: 'aps1.pure.cloud',
        dev: false,
    },
    {
        short: 'Tokyo',
        label: 'Asia Pacific',
        aws: 'ap-northeast-1',
        auth: 'https://login.mypurecloud.jp',
        api: 'https://api.mypurecloud.jp',
        apps: 'https://apps.mypurecloud.jp',
        env: 'mypurecloud.jp',
        dev: false,
    },
    {
        short: 'Seoul',
        label: 'Asia Pacific',
        aws: 'ap-northeast-2',
        auth: 'https://login.apne2.pure.cloud',
        api: 'https://api.apne2.pure.cloud',
        apps: 'https://apps.apne2.pure.cloud',
        env: 'apne2.pure.cloud',
        dev: false,
    },
    {
        short: 'Osaka',
        label: 'Asia Pacific',
        aws: 'ap-northeast-3',
        auth: 'https://login.apne3.pure.cloud',
        api: 'https://api.apne3.pure.cloud',
        apps: 'https://apps.apne3.pure.cloud',
        env: 'apne3.pure.cloud',
        dev: false,
    },
    {
        short: 'Singapore',
        label: 'Asia Pacific',
        aws: 'ap-southeast-1',
        auth: 'https://login.apse1.pure.cloud',
        api: 'https://api.apse1.pure.cloud',
        apps: 'https://apps.apse1.pure.cloud',
        env: 'apse1.pure.cloud',
        dev: false,
    },
    {
        short: 'Sydney',
        label: 'Asia Pacific',
        aws: 'ap-southeast-2',
        auth: 'https://login.mypurecloud.com.au',
        api: 'https://api.mypurecloud.com.au',
        apps: 'https://apps.mypurecloud.com.au',
        env: 'mypurecloud.com.au',
        dev: false,
    },
    {
        short: 'DCA',
        label: 'Genesys Internal',
        aws: 'us-east-1',
        auth: 'https://login.inindca.com',
        api: 'https://api.inindca.com',
        apps: 'https://apps.inindca.com',
        env: 'inindca.com',
        dev: true,
    },
    {
        short: 'TCA',
        label: 'Genesys Internal',
        aws: 'us-east-1',
        auth: 'https://login.inintca.com',
        api: 'https://api.inintca.com',
        apps: 'https://apps.inintca.com',
        env: 'inintca.com',
        dev: true,
    },
];

export default GenesysCloudAPIData;
